import { ICopTOFEConfiguration, TaskInfo } from 'top-api-sdk-angular';

import { SessionInfo } from '../types';

// TOP-22528: SK002 is overloaded on the backend — it means "session expired / unauthorized"
// in most call sites (AbstractCofeResource), not only "strong auth required". Treating it as a
// strong-auth trigger forced users of non-2FA processes (e.g. spidauth/CIE) onto the 2FA form,
// where /auth/2fa/generate then fails with SA001 (signer not configured for 2FA). Only SA008/SA009
// are unambiguous strong-auth signals, so SK002 must not synthesize a strong-auth session here.
export const STRONG_AUTH_ERROR_CODES = {
  SA008: 'SA008', // Strong authentication required. Please complete the 2FA process.
  SA009: 'SA009', // Strong authentication required. Please complete the 2FA process.
} as const;

export type StrongAuthErrorCode = (typeof STRONG_AUTH_ERROR_CODES)[keyof typeof STRONG_AUTH_ERROR_CODES];

export function isStrongAuthError(error: unknown): boolean {
  if (!error || typeof error !== 'object' || !('errorKey' in error)) {
    return false;
  }

  const errorCode = (error as { errorKey: string }).errorKey;
  return Object.values(STRONG_AUTH_ERROR_CODES).includes(errorCode as StrongAuthErrorCode);
}

export const createStrongAuthSession = (processId: string): SessionInfo => {
  return {
    id: processId,
    startData: {
      processStatus: 'WAITING_AUTHENTICATION',
      taskName: 'strongauth',
      taskId: processId,
    },
    processData: {
      tasks: [
        {
          name: 'strongauth',
          status: 'RUNNING',
          id: 1,
        } as TaskInfo,
      ],
      tofeConfiguration: {
        type: '',
        welcomePage: 'false',
      } as ICopTOFEConfiguration,
    },
  };
};
